import classNames from 'classnames'
import css from '../../global-nav.scss'

import { healthPath, helloBabyPath, indexPath, storePath } from 'lib/urls'

interface HomePageSiteNavSectionProps {
  activeNavItem?: string
  trackClick: (eventCta: string) => void
}

const HomePageSiteNavSection = ({
  activeNavItem,
  trackClick,
}: HomePageSiteNavSectionProps) => {
  return (
    <>
      <li
        className={classNames(
          'hidden-xs',
          css.navLink,
          css.registryLink,
          activeNavItem === 'Registry' && css.registryActive
        )}
      >
        {
          <a href={indexPath} onClick={() => trackClick('Registry')}>
            Registry
          </a>
        }
      </li>
      <li
        className={classNames(
          'hidden-xs',
          css.navLink,
          css.storeLink,
          activeNavItem === 'Store' && css.storeActive
        )}
      >
        <a href={storePath} onClick={() => trackClick('Shop')}>
          Shop
        </a>
      </li>
      <li
        className={classNames(
          'hidden-xs',
          css.navLink,
          css.guidesLink,
          activeNavItem === 'Guides' && css.guidesActive
        )}
      >
        <a href={helloBabyPath} onClick={() => trackClick('Guides')}>
          Guides
        </a>
      </li>
      <li className={classNames('hidden-xs', css.navLink)}>
        <a href={healthPath} onClick={() => trackClick('Health')}>
          Health
        </a>
      </li>
    </>
  )
}

export default HomePageSiteNavSection
